import { motion } from "framer-motion";
import { useLang } from "@/context/LangContext";

const Testimonials = () => {
  const { t } = useLang();
  return (
    <section
      data-testid="testimonials-section"
      className="relative py-24 md:py-32 lg:py-40 bg-[#F2EEE3]"
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-10 lg:px-16">
        <div className="grid grid-cols-12 gap-6 items-end mb-16 md:mb-24">
          <div className="col-span-12 md:col-span-8">
            <div className="font-eyebrow text-2xl md:text-[30px] text-[#0F3D2E]/85 mb-6">{t.testimonials.eyebrow}</div>
            <h2 className="font-serif-editorial text-[#0F3D2E] leading-[0.95] text-[10vw] sm:text-[8vw] md:text-[5.6vw] lg:text-[4.4vw]">
              {t.testimonials.title.split("\n").map((l, i) => (
                <span key={i} className="block">
                  {i === 1 ? <em className="italic text-[#2E8B4A]">{l}</em> : l}
                </span>
              ))}
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-12 gap-6">
          {t.testimonials.items.map((it, i) => (
            <motion.figure
              key={i}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ delay: i * 0.12, duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
              className={`col-span-12 md:col-span-4 relative p-8 md:p-10 rounded-2xl border border-[#E5DFCE] bg-[#FAF7F0] ${
                i === 1 ? "md:translate-y-6" : ""
              }`}
              data-testid={`testimonial-${i}`}
            >
              <div className="font-serif-editorial text-[#2E8B4A] text-6xl leading-none mb-4">“</div>
              <blockquote className="font-serif-editorial italic text-[#0F3D2E] text-xl md:text-[22px] leading-snug mb-8">
                {it.text}
              </blockquote>
              <figcaption className="flex items-center gap-3 pt-6 border-t border-[#E5DFCE]">
                <div className="w-9 h-9 rounded-full bg-[#0F3D2E]/10 flex items-center justify-center font-serif-editorial text-[#0F3D2E]">
                  {it.name[0]}
                </div>
                <div>
                  <div className="text-[13px] text-[#0F3D2E] font-medium">{it.name}</div>
                  <div className="text-[11px] tracking-[0.14em] uppercase text-[#0A1F17]/60">{it.role}</div>
                </div>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
